<template>
  <v-carousel
    class="height-arrow-benefits pa-0 ma-0"
    height="auto"
    hide-delimiters
  >
    <v-carousel-item
      v-for="(benefit, i) in data"
      :key="i"
      eager
      class="ma-0 pa-0"
    >
      <v-container class="ma-0 pa-0" fluid @mouseenter="createAnalyticsEvent()">
        <v-row class="ma-0 pr-md-10">
          <v-col align="center" cols="12" md="4" offset-md="1">
            <v-img
              contain
              :src="benefit.image"
              :alt="benefit.imageAlt && benefit.imageAlt"
              class="rounded-image"
              style="max-width: 400px"
            />
          </v-col>
          <v-col class="ma-0 pa-0" cols="12" md="7">
            <h3
              class="mt-5 mt-md-3 px-2 text-title headline text-center text-md-left"
            >
              {{ benefit.title }}
            </h3>
            <p class="mt-4 px-2 text-body" v-html="benefit.text" />
          </v-col>
        </v-row>
      </v-container>
    </v-carousel-item>
  </v-carousel>
</template>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.text-title
  font-size: 1.6em !important
  @media screen and (max-width: $sm)
    font-size: 1.4em !important
  @media screen and (max-width: $xs)
    font-size: 1.2em !important

.new-color
  .text-title
    font-family: 'metropolismedium' !important
    font-weight: normal !important
</style>

<style lang="sass">
@import '@/styles/util'

.height-arrow-benefits
  .v-window__next, .v-window__prev
    top: 140px

    @media screen and (max-width: $xs)
      top: 100px
</style>

<script>
export default {
  name: 'Benefits',
  props: {
    data: {
      type: Array,
      required: true,
    },
    eventCategory: {
      type: String,
      required: false,
      default: null,
    },
    eventIndex: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      createEventTrue: false,
    };
  },
  computed: {
    alignment() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'center';
        case 'sm':
          return 'center';
        case 'md':
          return 'center';
        case 'lg':
          return 'start';
        case 'xl':
          return 'start';
        default:
          return 'start';
      }
    },
  },
  methods: {
    createAnalyticsEvent() {
      if (
        !this.createEventTrue &&
        this.eventIndex !== null &&
        this.eventCategory !== null
      ) {
        const elementPrev = document.getElementsByClassName('v-window__prev');
        elementPrev[this.eventIndex].addEventListener('click', () =>
          this.$analytics(this.eventCategory, 'voltar'),
        );

        const elementNext = document.getElementsByClassName('v-window__next');
        elementNext[this.eventIndex].addEventListener('click', () =>
          this.$analytics(this.eventCategory, 'avançar'),
        );

        this.createEventTrue = true;
      }
    },
  },
};
</script>
